import { render } from "./CardItem.vue?vue&type=template&id=981db0a2&scoped=true&ts=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=981db0a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hotaru_theme/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981db0a2"]])

export default __exports__